<div class="email-preference-card p-4">
  <h3 class="crnt-typography-heading-3 mb-3 fw-bold">{{ title() }}</h3>
  <p class="crnt-typography-body-functional mb-4">{{ description() }}</p>
  <label class="checkbox-label d-flex align-items-center gap-2">
    <input
      type="checkbox"
      [checked]="checked()"
      [name]="controlName()"
      (change)="onCheckboxChange($event)"
    />
    <span class="crnt-typography-body-functional">Deze mails ontvangen</span>
  </label>
</div>
